import styled from "styled-components";
import { FaPlus, FaTrash } from "react-icons/fa";
import { Typography } from "antd";
import { darken, lighten } from "polished";

export const StyledPopupNode = styled.div<{ selected: boolean }>`
  background: ${({ theme, selected }) =>
    selected
      ? darken(0.2, theme.palette.background.default)
      : theme.palette.background.default};
  border-radius: 5px;
  border: 2px solid
    ${({ theme, selected }) =>
      selected
        ? theme.palette.primary.main
        : darken(0.2, theme.palette.primary.main)};
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.01);
  overflow: hidden;
  cursor: help;
`;

export const StyledPopupNodeContent = styled.div<{
  selected: boolean;
  width: number;
  height: number;
}>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding-bottom: 15px;
  cursor: help;

  &:hover {
    .node-actions {
      bottom: 2px;
      right: 2px;
    }
  }
`;

export const StyledPopupNodeHeader = styled.div`
  width: 100%;
  height: 18px;
  background: ${({ theme }) => lighten(0.3, theme.palette.black)};
  color: ${({ theme }) => theme.palette.white}!important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 5px;
  gap: 4px;

  .dots {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .middle-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: relative;

    &:nth-child(1) {
      background: #ff5f56; /* Close (red) */
    }

    &:nth-child(2) {
      background: #27c93f; /* Maximize (green) */
    }

    &:nth-child(3) {
      background: #ffbd2e; /* Minimize (yellow) */
    }
  }
`;

export const StyledNodeTitle = styled(Typography)`
  padding: 5px;
  font-size: 10px;
  color: inherit !important;
`;

export const StyledPopupNodeBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const StyledNodeDetail = styled(Typography.Text)`
  font-size: 18px;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  width: 80%;
`;

export const StyledNodeHover = styled.div`
  transition: all 0.3s ease;
  position: absolute;
  bottom: -20px;
  right: -2px;

  display: flex;
  width: 100%;
  height: 20px;
  z-index: 1000;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const StyledNodeAddButton = styled(FaPlus)`
  cursor: pointer;
`;

export const StyledNodeDeleteButton = styled(FaTrash)`
  cursor: pointer;
`;
